module.exports = __webpack_public_path__ + "img/aParty_110523_H.b1de4188.jpg";